import { render, staticRenderFns } from "./ActiveConversations.vue?vue&type=template&id=e0473d18"
import script from "./ActiveConversations.vue?vue&type=script&lang=ts"
export * from "./ActiveConversations.vue?vue&type=script&lang=ts"
import style0 from "./ActiveConversations.vue?vue&type=style&index=0&id=e0473d18&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports